export default __webpack_public_path__ + "mikumikudance.5f9ee0e3.png";